import {
  LayoutGrid, Mail, Users, FolderTree, ShieldCheck, MonitorSmartphone,
  Ticket, ListChecks, Phone, Printer, Laptop, Monitor, Briefcase, Palette, Sparkles,
} from "lucide-react";
import { Marquee } from "@/components/shadcn-space/animations/marquee";
import {
  ClaudeIcon, XcodeIcon, GitHubIcon, SupabaseIcon, VercelIcon, CloudflareIcon,
} from "./BrandIcons";
import Eyebrow from "./Eyebrow";

// Two logo bands in the style of the shadcn-space "Logo Cloud" block.
// Brand marks where a free one exists (Simple Icons), otherwise a matching line icon.
const WORKPLACE = [
  { name: "Microsoft 365", Icon: LayoutGrid },
  { name: "Exchange Online", Icon: Mail },
  { name: "Microsoft Teams", Icon: Users },
  { name: "SharePoint", Icon: FolderTree },
  { name: "Azure AD", Icon: ShieldCheck },
  { name: "Microsoft Intune", Icon: MonitorSmartphone },
  { name: "ServiceNow", Icon: Ticket },
  { name: "ITSM", Icon: ListChecks },
  { name: "3CX", Icon: Phone },
  { name: "Printix", Icon: Printer },
  { name: "Kandji", Icon: Laptop },
  { name: "Windows & macOS", Icon: Monitor },
  { name: "Google Workspace", Icon: Briefcase },
  { name: "Adobe Creative Cloud", Icon: Palette },
];

const BUILDING = [
  { name: "Claude Code", Icon: ClaudeIcon },
  { name: "AI Assisted Coding", Icon: Sparkles },
  { name: "Apple Xcode", Icon: XcodeIcon },
  { name: "GitHub", Icon: GitHubIcon },
  { name: "Supabase", Icon: SupabaseIcon },
  { name: "Vercel", Icon: VercelIcon },
  { name: "Cloudflare", Icon: CloudflareIcon },
];

const ToolLogo = ({ name, Icon }) => (
  <div
    className="flex items-center gap-3 whitespace-nowrap text-muted-foreground/80
               transition-colors duration-300 hover:text-accent"
  >
    <Icon className="size-7 shrink-0" strokeWidth={1.75} aria-hidden="true" />
    <span className="text-lg sm:text-xl font-semibold tracking-tight">{name}</span>
  </div>
);

const LogoBand = ({ label, items, reverse, duration }) => (
  <div className="space-y-4">
    <p className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 text-xs font-semibold uppercase tracking-widest text-muted-foreground">
      {label}
    </p>
    <div className="relative overflow-hidden">
      <Marquee
        pauseOnHover
        reverse={reverse}
        className="p-0 [--gap:3rem] lg:[--gap:4.5rem]"
        style={{ "--duration": duration }}
      >
        {items.map((t) => (
          <ToolLogo key={t.name} {...t} />
        ))}
      </Marquee>

      {/* Left fade */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-1/4 bg-gradient-to-r from-background to-transparent" />
      {/* Right fade */}
      <div className="pointer-events-none absolute inset-y-0 right-0 w-1/4 bg-gradient-to-l from-background to-transparent" />
    </div>
  </div>
);

const TechStack = () => (
  <section id="technologien" className="border-b py-16 sm:py-20 lg:py-28 overflow-hidden">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 space-y-2">
      <Eyebrow>Technologien & Tools</Eyebrow>
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
        Mein Werkzeugkasten
      </h2>
      <p className="text-muted-foreground text-base sm:text-lg max-w-2xl leading-relaxed pt-2">
        Im Zentrum steht die Microsoft-365-Administration, die ich über Jahre
        täglich gemacht habe. Dazu kommen Tools aus Support, ITSM und
        Endpoint-Management, mit denen ich Anliegen schnell und sauber löse,
        und ein moderner Entwickler-Stack für eigene Projekte.
      </p>
    </div>

    <div className="mt-12 lg:mt-16 space-y-10 lg:space-y-14">
      <LogoBand label="Arbeitsplatz, Support & Endpoints" items={WORKPLACE} duration="60s" />
      <LogoBand label="Entwicklung & AI" items={BUILDING} duration="40s" reverse />
    </div>
  </section>
);

export default TechStack;
